import { render } from "./PolylineMap.vue?vue&type=template&id=01244a87"
import script from "./PolylineMap.vue?vue&type=script&lang=js"
export * from "./PolylineMap.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__